import React from "react";

import { placeholderPermissions, pricingLevelList } from "@/App/constants/permissions";
import Dashboard from "@/App/pages/Dashboard";
import PricingLevelCreate from "@/App/pages/PricingLevels/pages/Create";
import PricingLevels from "@/App/pages/PricingLevels/pages/List";
import PricingLevelUpdate from "@/App/pages/PricingLevels/pages/Update";

interface RouteProps {
  path: string;
  Component: React.FC<{ pageTitle: string }> | React.ComponentClass;
  pageTitle: string;
  label?: string;
  iconClassName?: string;
  inMainMenu: boolean;
  requiredPermissions: Array<string>;
  breadcrumb?: React.FC | string;
  exact?: boolean;
  isActive?: (match: {}, location: { pathname: string }) => boolean;
  redirectTo?: string;
}

export const appRoutes: Array<RouteProps> = [
  {
    path: "/",
    Component: Dashboard,
    pageTitle: "Dashboard",
    label: "Dashboard",
    iconClassName: "caprx-icon-home",
    inMainMenu: true,
    requiredPermissions: placeholderPermissions, // update
    breadcrumb: "Dashboard",
  },
  {
    path: "/pricing-levels",
    Component: PricingLevels,
    label: "Pricing",
    pageTitle: "Pricing",
    inMainMenu: false,
    requiredPermissions: pricingLevelList,
    breadcrumb: "Pricing",
    exact: false,
  },
  {
    path: "/pricing-levels/create",
    Component: PricingLevelCreate,
    label: "Pricing Level - Create",
    pageTitle: "Pricing Level - Create",
    inMainMenu: false,
    requiredPermissions: pricingLevelList,
    breadcrumb: "Create",
    exact: false,
  },
  {
    path: "/pricing-levels/:id",
    Component: null,
    pageTitle: "",
    inMainMenu: false,
    requiredPermissions: pricingLevelList,
    breadcrumb: null,
  },
  {
    path: "/pricing-levels/:id/edit",
    Component: PricingLevelUpdate,
    label: "Pricing Level - Update",
    pageTitle: "Pricing Level - Update",
    inMainMenu: false,
    requiredPermissions: pricingLevelList,
    breadcrumb: "Update",
    exact: false,
  },
];
